import React from 'react';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import { Alert } from 'reactstrap';
import { toasty } from '../common/forms/FormElements';

export default class NotificationFailureResultTable extends React.Component {
    handleRowClick = (result) => {
        const json = JSON.stringify(result, null, 2);
        navigator.clipboard.writeText(json).then(() => {
            toasty.success(
                'This notification failure data has been copied to your clipboard.'
            );
        });
    };
    render() {
        const { loading, results } = this.props;

        if (loading) {
            return null;
        }

        if (!results.length) {
            return (
                <div className="mt-3">No notification failures were found.</div>
            );
        }

        return (
            <div>
                <Alert color="info" className="mt-2 mb-2" fade={false}>
                    <div>
                        Search returned {results.length} notification failures.
                    </div>
                    <div>
                        Clicking a notification failure will copy its JSON to
                        the clipboard.
                    </div>
                </Alert>
                <div className="table-responsive mt-3">
                    <table className="table table-striped table-sm">
                        <thead>
                            <tr>
                                <th>Date / Time</th>
                                <th>Employee</th>
                                <th>Type</th>
                                <th>Destination</th>
                                <th width="33%">Message Content</th>
                                <th width="33%">Error Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((result) => (
                                <tr
                                    key={result.id}
                                    className="notification-failure-row"
                                    onClick={() => this.handleRowClick(result)}
                                    title="Click to copy JSON to clipboard"
                                >
                                    <td>
                                        {moment(result.logTime).format(
                                            MomentDateFormat.DateTimeShortAnte
                                        )}
                                    </td>
                                    <td>
                                        {result.employee && (
                                            <>
                                                {result.employee.fullName} (
                                                {result.employee.employeeNumber}
                                                )
                                            </>
                                        )}

                                        {!result.employee && <>N/A</>}
                                    </td>
                                    <td>{result.email ? 'Email' : 'SMS'}</td>
                                    <td>{result.destination}</td>
                                    <td className="overflow-wrapper">
                                        {result.messageContent}
                                    </td>
                                    <td className="overflow-wrapper">
                                        {result.errorMessage}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
